<template>
  <div :data-testid="dataTestid" aria-hidden="true">
    <VChart :option="option" :theme="OMR_ECHARTS_THEME" autoresize class="h-full w-full" :data-testid="`${dataTestid}-chart`" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { OMR_ECHARTS_THEME } from '@/composables/useOmrEchartsTheme'
import { VChart, type OmrEChartsOption } from '@/config/echarts'

const BAR_RADIUS = 4

const props = withDefaults(
  defineProps<{
    value: number
    max: number
    color: string
    trackColor: string
    marker?: number | null
    markerColor?: string
    markerLabel?: string
    dataTestid?: string
  }>(),
  { marker: null, markerColor: undefined, markerLabel: undefined, dataTestid: 'insights-track-bar' },
)

const option = computed<OmrEChartsOption>(() => ({
  grid: { top: 0, left: 0, right: 0, bottom: 0 },
  ...(props.markerLabel && { tooltip: { trigger: 'item', position: 'top', appendToBody: true } }),
  xAxis: { type: 'value', min: 0, max: props.max, show: false },
  yAxis: { type: 'category', data: [''], show: false },
  series: [
    {
      type: 'bar',
      data: [props.value],
      barWidth: '100%',
      silent: !props.markerLabel,
      emphasis: { disabled: true },
      tooltip: { show: false },
      clip: false,
      itemStyle: { color: props.color, borderRadius: BAR_RADIUS },
      showBackground: true,
      backgroundStyle: { color: props.trackColor, borderRadius: BAR_RADIUS },
      ...(props.marker != null && {
        markLine: {
          silent: !props.markerLabel,
          symbol: 'none',
          label: { show: false },
          lineStyle: { color: props.markerColor, width: 2, type: 'solid' },
          emphasis: { lineStyle: { width: 4 } },
          tooltip: { formatter: () => props.markerLabel ?? '' },
          data: [{ xAxis: props.marker }],
        },
      }),
    },
  ],
}))
</script>
